export abstract class IJobResumeDto {
	PathType: number;

	constructor(pathType: number) {
		this.PathType = pathType
	}
}